/**
 * Enum for Wathiq form section names
 */
export enum WathiqSectionName {
  MANAGERS = 'managers',
  AUTHORIZED_SIGNATORIES = 'authorizedSignatories',
}
